import { useI18n } from '@cascade/react/i18n';
import { useProjects } from '@cascade/react/projects';
import { Text } from '@cascade/ui-library';
import classes from './AgentIntro.module.scss';

export const AgentIntro = () => {
  const { translate } = useI18n();
  const { customizableMessages } = useProjects();

  const title = customizableMessages?.title;

  const description =
    customizableMessages?.description || translate('agent.intro.description');

  return (
    <header className={classes['agent-intro']}>
      {title ? (
        <Text type='h1' weight='semibold' content={title} compact />
      ) : null}
      <Text type='subtitle' color='text-60' content={description} compact />
    </header>
  );
};
